export default "__VITE_ASSET__CiHf2ZqK__"